module.exports = __webpack_public_path__ + "img/Villarreal.3ff98afa.png";